module.exports = __webpack_public_path__ + "media/packs/images/flags/YE-3127f86e92da47d14a4d2a05106091d3.png";